/*
 * @@Description:
 * @@Author: MuYang
 * @Date: 2021-09-23 14:08:57
 * @LastEditTime: 2021-09-26 10:41:39
 */
import './index.scss'
const i18n = {
  'zh-CN': {text: '暂无数据'},
  'en': {text: 'NO DATA'}
}
const pageText = window.fe.getPageText(i18n)
export default {
  render (h) {
    return (
      <div class='sy-placeholder'>
        <div class='sy-empty'>
          <div class='sy-empty-image'>
            <img src='//img.sunyur.com/166417300719294468.svg'></img>
          </div>
          <p class="sy-empty-description">{pageText.text}</p>
        </div>
      </div>
    )
  }
}
